<template>
  <div class="nuttrema-medium-editor" :class="[ disabled ? 'is-disabled' : '' ]">
    <medium-editor
       custom-tag='div'
      :text='text'
      :options='options'
      @edit='applyTextEdit'/>
      <p v-if="showHint" class="nuttrema-medium-editor__help" v-html="_markdown.renderInline($t(hintLabel))"></p>
  </div>
</template>

<script>
import { merge } from 'lodash';
import MediumEditor from 'vue2-medium-editor';
import MarkdownIt from 'markdown-it';
import MarkdownItIns from 'markdown-it-ins';
import TurndownService from 'turndown';

const turndownService = new TurndownService();

const markdownService = new MarkdownIt({
  html: true,
  breaks: true,
});

markdownService.use(MarkdownItIns);

export default {
  name: 'nuttrema-medium-editor',
  components: { MediumEditor },
  props: {
    value: {
      default: null,
      required: true,
    },
    defaultOptions: {
      type: Object,
      required: false,
      default: () => ({
        toolbar: {
          buttons: ['bold', 'italic', 'underline'],
        },
        placeholder: false,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    hintLabel: {
      type: String,
      default: 'label.you_can_use_html',
    },
    multiLine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: null,
      md: null,
    };
  },
  computed: {
    options() {
      return merge(
        {
          disableEditing: !this.edit,
          disableReturn: !this.multiLine,
        },
        this.defaultOptions
      );
    },
  },
  methods: {
    applyTextEdit(ev) {
      if (ev.event.target) {
        this.text = ev.event.target.innerHTML;
        this.md = turndownService.turndown(ev.event.target.innerHTML);
        this.$emit('input', this.md);
      }
    },
  },
  created() {
    if (this.multiLine) {
      turndownService.addRule('paragraph', {
        filter: 'p',
        replacement: content => `\n${content}\n`,
      });
    }

    turndownService.addRule('underline', {
      filter: 'u',
      replacement: content => `++${content}++`,
    });

    this.text = this.value ? markdownService.renderInline(this.value) : null;
  },
};
</script>

<style lang="scss">
@import './nuttrema-medium-editor';

.nuttrema-medium-editor__help {
  padding: 0 0.5em;
  margin-top: 0.5em;
  font-size: 0.85em;
  text-align: right;
  line-height: 1.35;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/editor/nuttrema-medium-editor.vue